import { render, staticRenderFns } from "./BaseInfoAlert.vue?vue&type=template&id=7d8c793c&scoped=true"
import script from "./BaseInfoAlert.vue?vue&type=script&lang=js"
export * from "./BaseInfoAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c793c",
  null
  
)

export default component.exports